<div class="w-full px-6 py-8 space-y-10">
    <form [formGroup]="form" (ngSubmit)="onSubmit1()" class="space-y-10">
      
      <!-- Section: Lead Info -->
      <div class="bg-white rounded-2xl shadow-lg p-6 space-y-6">
        <div class="flex items-center gap-2 border-b pb-2">
          <div class="w-[4px] h-6 bg-primary"></div>
          <h2 class="text-xl font-semibold text-gray-800"> Contact</h2>
        </div>
  
        <div class="user-group grid grid-cols-12  pt-4 px-6 gap-8">
          <ng-container *ngFor="let field of leadFields">
            <div class="col-span-6">

              <mat-label>{{ field.label }} <span *ngIf="field.required">*</span></mat-label>

            <mat-form-field appearance="outline" class="w-full bg-white rounded-md">
  
              <ng-container [ngSwitch]="field.type">
                <mat-select *ngSwitchCase="'select'" [formControlName]="field.name">
                  <mat-option value="">Select</mat-option>
                  <mat-option value="Mr">Mr</mat-option>
                  <mat-option value="Ms">Ms</mat-option>
                </mat-select>
  
                <textarea *ngSwitchCase="'textarea'" matInput rows="2" [formControlName]="field.name"></textarea>
  
                <input *ngSwitchDefault matInput type="text" [formControlName]="field.name" />
              </ng-container>
  
              <mat-error *ngIf="submitted && f[field.name].errors?.['required']">
                {{ field.label }} is required
              </mat-error>
            </mat-form-field>
              </div>

          </ng-container>
        </div>
      </div>
  
      <!-- Section: Contact Details -->
      <div class="bg-white rounded-2xl shadow-lg p-6 space-y-6">
        <div class="flex items-center gap-2 border-b pb-2">
          <div class="w-[4px] h-6 bg-primary"></div>
          <h2 class="text-xl font-semibold text-gray-800">Contact Details</h2>
        </div>
  
        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          <ng-container *ngFor="let field of contactFields">
            <div class="col-span-6">
              <mat-label>{{ field.label }}</mat-label>

            <mat-form-field appearance="outline" class="w-full bg-white rounded-md">
              <input matInput type="text" [formControlName]="field.name" />
            </mat-form-field>
            </div>
          </ng-container>
        </div>
      </div>
  
      <!-- Submit Button -->
      <div class="flex justify-end">
        <button mat-raised-button color="primary" type="submit" class="rounded-xl px-6 py-2">
          Register
        </button>
      </div>
    </form>
  </div>
  
